import { Select, Tag } from "antd";
import React, { useEffect, useRef, useState } from "react";

import ajaxUtil from "../../util/ajax";

const { DOMAIN_CURRENT, ajaxv2 } = ajaxUtil;
export const MULTI_GALLERY_SELECT_TOGGLE_EVENT =
  "decoratev2:multi-gallery-select-toggle";
const COLLAPSE_SETTLE_DELAY = 260;

const { Option } = Select;

window.__cached_gallery_list = null;

export default function MultiGallerySelect(props) {
  const { value, onChange, mode } = props;
  const [list, setList] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const selectRef = useRef(null);
  const openTimerRef = useRef(null);

  const isMultiple = mode !== "single";

  const getList = async function () {
    const gallery = window.decorateGetGallery();
    const res =
      window.__cached_gallery_list ||
      (await ajaxv2({
        url: DOMAIN_CURRENT + `/api/v2/gallery/${gallery.id}/childlist`,
      }));
    window.__cached_gallery_list = res;
    let list = (res || []).map((it) => ({
      key: it.id,
      name: it.name,
      img_count: it.img_count,
      check: it.check,
      privacy: it.privacy,
    }));
    if (list.length <= 0) {
      list.unshift({
        key: gallery.id,
        name: gallery.name,
        img_count: gallery.img_count,
        check: gallery.check,
        privacy: gallery.privacy,
      });
    }
    setList(list);
  };

  useEffect(() => {
    getList();
    return () => {
      if (openTimerRef.current) {
        clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
      }
      window.__cached_gallery_list = null;
    };
  }, []);

  const clearPendingOpenTimer = () => {
    if (openTimerRef.current) {
      clearTimeout(openTimerRef.current);
      openTimerRef.current = null;
    }
  };

  const renderGalleryName = (one) => (
    <React.Fragment>
      {one.check ? <Tag color="red" style={{
        color: 'darkred',
      }}>审核</Tag> : null}
      {one.privacy !== "normal" ? <Tag color="orange">私密</Tag> : null}
      <Tag>{one.img_count}张</Tag>
      {one.name}
    </React.Fragment>
  );

  const notifyDecorateProperties = (open) => {
    if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
      return;
    }
    window.dispatchEvent(
      new CustomEvent(MULTI_GALLERY_SELECT_TOGGLE_EVENT, {
        detail: { open, source: "MultiGallerySelect" },
      })
    );
  };

  const shouldDelayDropdownOpen = () =>
    isMultiple && typeof window !== "undefined" && window.innerHeight <= 900;

  const openDropdownAfterCollapse = () => {
    clearPendingOpenTimer();
    openTimerRef.current = setTimeout(() => {
      setDropdownVisible(true);
      if (selectRef.current && typeof selectRef.current.focus === "function") {
        selectRef.current.focus();
      }
      openTimerRef.current = null;
    }, COLLAPSE_SETTLE_DELAY);
  };

  const handleDropdownVisibleChange = (open) => {
    if (!open) {
      clearPendingOpenTimer();
      setDropdownVisible(false);
      return;
    }

    if (shouldDelayDropdownOpen()) {
      setDropdownVisible(false);
      notifyDecorateProperties(true);
      openDropdownAfterCollapse();
      return;
    }

    clearPendingOpenTimer();
    setDropdownVisible(true);
  };

  return (
    <Select
      ref={selectRef}
      mode={isMultiple ? "multiple" : undefined}
      style={{ width: props.width }}
      value={value}
      open={dropdownVisible}
      onChange={onChange}
      onDropdownVisibleChange={handleDropdownVisibleChange}
      showSearch
      optionFilterProp="label"
      filterOption={(input, option) =>{        
        return `${option?.label||option?.props?.label}`.toLowerCase().includes(input.toLowerCase());
      }
        
      }
      tokenSeparators={[","]}
      {...(props.selectProps || {})}
    >
      {list.map((one) => (
        <Option key={`${one.key}`} label={one.name}>
          {renderGalleryName(one)}
        </Option>
      ))}
    </Select>
  );
}


// WEBPACK FOOTER //
// ./src/components/Select/MultiGallerySelect.js